'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("fileImageWithSize", function (security, urlUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div><img ng-src="{{filePath}}"><div class="size">{{width}}*{{height}}px</div></div>',
    link: function link($scope, $el, $attrs) {
      $scope.filePath = null;
      $attrs.$observe("url", function (url) {
        $scope.filePath = urlUtils.addParams(url, security.getTokens());
      });
      $el.find('img').on("load", function () {
        var img = $el.find('img')[0];
        $scope.width = img.naturalWidth;
        $scope.height = img.naturalHeight;
        $scope.$digest();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/fileImageWithSize.js
// module id = 2939
// module chunks = 13